module.exports = "/assets/8c3c06a47573071d2cf0a7b0d4f80e49.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/7K.png
// module id = 1114
// module chunks = 0